import ApiService from './ApiService'

export async function apiSignIn(data) {
    try {
        const response = await ApiService.fetchData({
            url: '/v1/users/auth-login',
            method: 'POST',
            data,
        })
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

export async function apiProfile() {
    try {
        const response = await ApiService.fetchData({
            url: '/v1/users/me',
            method: 'GET',
        })
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

export async function forgotPasswordAPI(data) {
    return ApiService.fetchData({
        url: '/v1/users/password-reset-request',
        method: 'PATCH',
        data,
    })
}

export async function resetPasswordApi(data) {
    return ApiService.fetchData({
        url: '/v1/users/password-reset',
        method: 'PATCH',
        data,
    })
}

export async function changePasswordApi(payload) {
    try {
        const response = await ApiService.fetchData({
            url: '/v1/users/change-password',
            method: 'PATCH',
            data: payload,
        })
        return Promise.resolve(response.data)
    } catch (error) {
        if (error?.response?.status === 404) {
            return Promise.reject('404: path not found')
        }

        return Promise.reject(error?.response?.data?.message)
    }
}
